/** @format */

import {TanStackTableData} from 'components/Table/core/types';

import {Campaign} from '../../../types';

export const mapCampaignsToTableData = (campaigns: Campaign[]): TanStackTableData[] => {
  return campaigns.map(campaign => ({
    id: campaign.id,
    name: campaign.name,
    accountName: campaign.accountName || '',
  }));
};

